import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"header-left\"><svg width=\"38\" height=\"38\" viewBox=\"0 0 38 38\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"38\" height=\"38\" rx=\"19\" fill=\"#003D84\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.2241 13.2666C23.3902 13.2665 23.5496 13.3325 23.6671 13.45L24.5507 14.3336C24.6682 14.4511 24.7341 14.6104 24.734 14.7766C24.7339 14.9428 24.6678 15.1021 24.5502 15.2194L13.7002 26.0448C13.654 26.0908 13.601 26.1294 13.543 26.1591L11.7855 27.0575C11.5438 27.1811 11.2499 27.1347 11.0579 26.9428C10.8659 26.7508 10.8195 26.4569 10.9431 26.2151L11.8416 24.4573C11.8712 24.3993 11.9098 24.3462 11.9558 24.3001L22.7812 13.4505C22.8986 13.3328 23.0579 13.2667 23.2241 13.2666Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.994 11.2414C25.2289 11.0066 25.5474 10.8748 25.8795 10.8748C26.2117 10.8748 26.5302 11.0066 26.7651 11.2414L26.3226 11.6842L26.7654 11.2417C27.0002 11.4766 27.1321 11.7952 27.1321 12.1273C27.1321 12.4594 27.0002 12.778 26.7654 13.0129L26.7654 13.0129L25.8793 13.8995C25.7619 14.0169 25.6026 14.0829 25.4365 14.0829C25.2704 14.0829 25.1111 14.0169 24.9937 13.8995L24.1076 13.0129C23.8632 12.7684 23.8632 12.3721 24.1077 12.1277L24.9938 11.2416L25.4364 11.6842L24.994 11.2414ZM25.879 12.1271L25.4356 12.5705L25.4365 12.5713L25.8798 12.1278\" fill=\"white\"></path></svg><div class=\"header-text\"><span class=\"header-title\">Cadastrar Assinatura</span><span class=\"header-subtitle\">Utilize os campos abaixo para gerar/editar sua assinatura:</span></div></div>", 1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.23654 7.23776C7.57798 6.89633 8.13155 6.89633 8.47298 7.23776L20.6926 19.4574C21.0341 19.7989 21.0341 20.3524 20.6926 20.6939C20.3512 21.0353 19.7976 21.0353 19.4562 20.6939L7.23654 8.4742C6.89511 8.13277 6.89511 7.5792 7.23654 7.23776Z",
    fill: "#888888"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20.6926 7.23776C21.0341 7.5792 21.0341 8.13277 20.6926 8.4742L8.47298 20.6939C8.13155 21.0353 7.57798 21.0353 7.23654 20.6939C6.89511 20.3524 6.89511 19.7989 7.23654 19.4574L19.4562 7.23776C19.7976 6.89633 20.3512 6.89633 20.6926 7.23776Z",
    fill: "#888888"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"signature-alert\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"#22B9FF\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.25 11.6253C2.25 6.4474 6.44838 2.24902 11.6263 2.24902C16.8041 2.24902 21.0025 6.4474 21.0025 11.6253C21.0025 16.8032 16.8041 21.0015 11.6263 21.0015C6.44838 21.0015 2.25 16.8032 2.25 11.6253ZM11.6263 3.75153C7.27819 3.75153 3.75251 7.27722 3.75251 11.6253C3.75251 15.9733 7.27819 19.499 11.6263 19.499C15.9743 19.499 19.5 15.9733 19.5 11.6253C19.5 7.27722 15.9743 3.75153 11.6263 3.75153Z\" fill=\"#22B9FF\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.56152 10.3138C9.56152 9.89885 9.89787 9.5625 10.3128 9.5625H11.8134C12.2283 9.5625 12.5646 9.89885 12.5646 10.3138V15.7535C12.5646 16.1684 12.2283 16.5047 11.8134 16.5047C11.3985 16.5047 11.0621 16.1684 11.0621 15.7535V11.065H10.3128C9.89787 11.065 9.56152 10.7287 9.56152 10.3138Z\" fill=\"#22B9FF\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.99805 15.9383C8.99805 15.5234 9.3344 15.187 9.7493 15.187H13.8773C14.2922 15.187 14.6286 15.5234 14.6286 15.9383C14.6286 16.3532 14.2922 16.6895 13.8773 16.6895H9.7493C9.3344 16.6895 8.99805 16.3532 8.99805 15.9383Z\" fill=\"#22B9FF\"></path><path d=\"M11.63 6.09473C11.3882 6.09473 11.1519 6.16641 10.9509 6.30071C10.7499 6.43501 10.5933 6.6259 10.5008 6.84924C10.4082 7.07257 10.384 7.31832 10.4312 7.55541C10.4784 7.79251 10.5948 8.01029 10.7657 8.18122C10.9366 8.35215 11.1544 8.46856 11.3915 8.51572C11.6286 8.56288 11.8744 8.53868 12.0977 8.44617C12.321 8.35366 12.5119 8.197 12.6462 7.99601C12.7805 7.79501 12.8522 7.5587 12.8522 7.31697C12.8522 6.99281 12.7234 6.68193 12.4942 6.45271C12.265 6.2235 11.9541 6.09473 11.63 6.09473Z\" fill=\"#22B9FF\"></path></svg> Esta assinatura aparecerá em todos os certificados emitidos por este curso/aula. Ela fica associada à versão atual do conteúdo. </div>", 1)
const _hoisted_9 = { class: "signature-info" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label cor_texto_1" }, "Nome do responsável:", -1)
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label cor_texto_1" }, "Cargo/função:", -1)
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label cor_texto_1" }, "Empresa Responsável:", -1)
const _hoisted_16 = { class: "signature-content" }
const _hoisted_17 = { class: "signature-tabs" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_2177_1006)\"><path d=\"M4.75178 2.48389C4.96053 2.48395 5.14723 2.61361 5.22053 2.80908L8.97151 12.811C9.06865 13.0701 8.93757 13.3594 8.67854 13.4565C8.41949 13.5537 8.13018 13.4216 8.03303 13.1626L4.75081 4.41064L1.46956 13.1626C1.37244 13.4216 1.08401 13.5535 0.825024 13.4565C0.565975 13.3594 0.434912 13.0701 0.532055 12.811L4.28303 2.80908L4.31526 2.73877C4.40302 2.58305 4.5691 2.48389 4.75178 2.48389Z\" fill=\"#888888\"></path><path d=\"M7.19043 8.98584C7.467 8.98595 7.69141 9.21022 7.69141 9.48682C7.69141 9.76342 7.467 9.98769 7.19043 9.98779H2.31348C2.03681 9.98779 1.8125 9.76348 1.8125 9.48682C1.8125 9.21015 2.03681 8.98584 2.31348 8.98584H7.19043Z\" fill=\"#888888\"></path><path d=\"M14.5033 12.9873V8.48633C14.5033 7.8587 14.2832 7.36568 13.9418 7.03027C13.5992 6.69377 13.1047 6.48644 12.5043 6.48633C11.6699 6.48633 10.9527 6.97339 10.6518 7.68164C10.5436 7.93621 10.2492 8.05447 9.99455 7.94629C9.74031 7.83795 9.62191 7.54447 9.7299 7.29004C10.191 6.20477 11.2758 5.48438 12.5043 5.48438C13.341 5.48449 14.096 5.77727 14.644 6.31543C15.1934 6.85521 15.5053 7.61363 15.5053 8.48633V12.9873C15.5051 13.2638 15.2808 13.4883 15.0043 13.4883C14.7278 13.4882 14.5036 13.2637 14.5033 12.9873Z\" fill=\"#888888\"></path><path d=\"M15.0044 8.73584C15.281 8.73592 15.5054 8.9602 15.5054 9.23682V9.70557C15.5054 11.0389 15.1139 12.0189 14.4116 12.6587C13.7183 13.2903 12.7983 13.52 11.8784 13.52C11.2507 13.52 10.6554 13.3117 10.2124 12.9038C9.76452 12.4913 9.50153 11.9014 9.50146 11.2065C9.50146 10.417 9.87036 9.84808 10.3911 9.479C10.8894 9.12599 11.5141 8.96146 12.0698 8.896C13.1595 8.76781 14.3688 8.73584 15.0044 8.73584ZM10.5034 11.2065C10.5035 11.6368 10.6603 11.9539 10.8911 12.1665C11.127 12.3837 11.4703 12.5181 11.8784 12.5181C12.6463 12.518 13.2893 12.3261 13.7368 11.9185C14.1706 11.5233 14.4952 10.857 14.5024 9.74365C13.8613 9.75703 12.9854 9.79719 12.187 9.89111C11.7185 9.9463 11.2797 10.0779 10.9712 10.2964C10.6853 10.4989 10.5034 10.777 10.5034 11.2065Z\" fill=\"#888888\"></path></g><defs><clipPath id=\"clip0_2177_1006\"><rect width=\"16.0035\" height=\"16.0035\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.3818 3.41406C11.5147 3.41399 11.6423 3.46677 11.7363 3.56079L12.4433 4.26781C12.5373 4.36183 12.5901 4.48936 12.59 4.62232C12.59 4.75528 12.537 4.88275 12.4429 4.97666L3.76102 13.6389C3.7241 13.6757 3.68166 13.7065 3.63523 13.7303L2.22899 14.4492C2.03554 14.5481 1.80039 14.511 1.64675 14.3574C1.49312 14.2038 1.45602 13.9686 1.5549 13.7752L2.27381 12.3686C2.29755 12.3221 2.3284 12.2797 2.36525 12.2428L11.0274 3.56118C11.1214 3.46706 11.2488 3.41414 11.3818 3.41406Z",
    fill: "#888888"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.7978 1.79339C12.9858 1.60553 13.2407 1.5 13.5064 1.5C13.7722 1.5 14.0271 1.60553 14.2151 1.79339L13.8609 2.14773L14.2153 1.79362C14.4031 1.98161 14.5087 2.23649 14.5087 2.50225C14.5087 2.76802 14.4031 3.0229 14.2153 3.21089L14.2152 3.21093L13.5062 3.92029C13.4122 4.01429 13.2848 4.06709 13.1519 4.06709C13.019 4.06709 12.8915 4.01429 12.7976 3.92029L12.0885 3.21093C11.893 3.01528 11.893 2.69816 12.0886 2.50256L12.7977 1.79351L13.1519 2.14769L12.7978 1.79339ZM13.506 2.50207L13.1512 2.85686L13.1519 2.85755L13.5066 2.50268",
    fill: "#888888"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.4988 9.25065V2.75011C12.4987 2.55169 12.4203 2.36132 12.2801 2.22093C12.1396 2.08044 11.9486 2.00126 11.7499 2.00125H4.24962C4.05103 2.00132 3.86087 2.08049 3.72044 2.22093C3.58001 2.36136 3.50083 2.55151 3.50076 2.75011V9.25065C3.50083 9.44924 3.58001 9.63939 3.72044 9.77983C3.86087 9.92026 4.05103 9.99943 4.24962 9.99951H5.50032C5.77673 9.99974 6.00119 10.2239 6.00119 10.5004C6.00119 10.7768 5.77673 11.001 5.50032 11.0012H4.24962C3.78537 11.0012 3.33989 10.8169 3.01161 10.4887C2.68333 10.1604 2.49909 9.7149 2.49902 9.25065V2.75011C2.4991 2.28585 2.68333 1.84038 3.01161 1.5121C3.33989 1.18381 3.78537 0.999584 4.24962 0.999512H11.7499C12.2142 0.999525 12.6596 1.18383 12.988 1.5121C13.3162 1.84038 13.5005 2.28585 13.5005 2.75011V9.25065C13.5005 9.7149 13.3162 10.1604 12.988 10.4887C12.6596 10.8169 12.2142 11.0012 11.7499 11.0012H10.5002C10.2236 11.0012 9.99934 10.777 9.99934 10.5004C9.99935 10.2238 10.2236 9.99951 10.5002 9.99951H11.7499C11.9486 9.99949 12.1396 9.92031 12.2801 9.77983C12.4203 9.63943 12.4987 9.44906 12.4988 9.25065Z",
    fill: "#888888"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.7257 4.58132C7.9201 4.45298 8.18431 4.47365 8.35545 4.64479L10.8559 7.14522C11.0513 7.3408 11.0514 7.65849 10.8559 7.85405C10.6603 8.0496 10.3426 8.04953 10.147 7.85405L8.00103 5.70803L5.85501 7.85405C5.65944 8.04959 5.34176 8.04959 5.14618 7.85405C4.95061 7.65847 4.95063 7.34081 5.14618 7.14522L7.64662 4.64479L7.7257 4.58132Z",
    fill: "#888888"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.49951 14.5004V5.50038C7.49951 5.22377 7.72377 4.99951 8.00038 4.99951C8.27698 4.99951 8.50125 5.22377 8.50125 5.50038V14.5004C8.50125 14.777 8.27698 15.0012 8.00038 15.0012C7.72377 15.0012 7.49951 14.777 7.49951 14.5004Z",
    fill: "#888888"
  })
], -1)
const _hoisted_21 = {
  class: "signature-section d-flex flex-1",
  style: {"gap":"1rem","flex-direction":"column"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { style: {"color":"#888888"} }, " Assine no campo abaixo com o mouse ou toque ", -1)
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"#888888\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.8164 3.18506H10.8164V2.42881C10.8164 1.74131 10.2539 1.18506 9.56953 1.18506H7.06016C6.37266 1.18506 5.81328 1.74756 5.81641 2.43506V3.18506H2.81641C2.54141 3.18506 2.31641 3.41006 2.31641 3.68506C2.31641 3.96006 2.54141 4.18506 2.81641 4.18506H3.34766L3.94453 13.7132C3.98828 14.5507 4.63203 15.1851 5.44453 15.1851H11.1945C12.0102 15.1851 12.6414 14.5663 12.6945 13.7163L13.2914 4.18506H13.8227C14.0977 4.18506 14.3227 3.96006 14.3227 3.68506C14.3227 3.41006 14.0977 3.18506 13.8227 3.18506H13.8164ZM6.81641 2.43506C6.81641 2.29756 6.92578 2.18818 7.06328 2.18506H9.56953C9.70703 2.18506 9.81641 2.29443 9.81641 2.43193V3.18506H6.81641V2.43506ZM11.6914 13.6538C11.6727 13.9726 11.4695 14.1851 11.1914 14.1851H5.44141C5.15703 14.1851 4.95703 13.9726 4.94141 13.6601C4.94141 13.6601 4.94141 13.6569 4.94141 13.6538L4.35078 4.18506H12.2852L11.6945 13.6538H11.6914Z\" fill=\"#ED2B46\"></path><path d=\"M8.31641 5.18506C8.04141 5.18506 7.81641 5.41006 7.81641 5.68506V12.6851C7.81641 12.9601 8.04141 13.1851 8.31641 13.1851C8.59141 13.1851 8.81641 12.9601 8.81641 12.6851V5.68506C8.81641 5.41006 8.59141 5.18506 8.31641 5.18506Z\" fill=\"#ED2B46\"></path><path d=\"M6.04795 5.18535C5.77295 5.19473 5.55733 5.42598 5.5667 5.7041L5.8167 12.7041C5.82608 12.9729 6.04795 13.1854 6.3167 13.1854C6.58545 13.1854 6.3292 13.1854 6.33545 13.1854C6.61045 13.176 6.82608 12.9447 6.8167 12.6666L6.5667 5.6666C6.55733 5.3916 6.32608 5.17598 6.04795 5.18535Z\" fill=\"#ED2B46\"></path><path d=\"M10.0667 5.6666L9.8167 12.6666C9.80733 12.9416 10.023 13.1729 10.298 13.1854C10.3042 13.1854 10.3105 13.1854 10.3167 13.1854C10.5855 13.1854 10.8073 12.9729 10.8167 12.7041L11.0667 5.7041C11.0761 5.4291 10.8605 5.19785 10.5855 5.18535C10.3105 5.17598 10.0792 5.3916 10.0667 5.6666Z\" fill=\"#ED2B46\"></path></svg>", 1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","gap":"1rem","width":"100%","height":"182.5px","border-radius":"1.2rem","background":"#FBFBFB","border":"#CFCFCF dashed 1.5px"}
}
const _hoisted_26 = {
  viewBox: "0 0 24 24",
  fill: "#464E5F",
  style: {"height":"2rem"},
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", { d: "M18.7482 13.8757V4.12492C18.7481 3.82729 18.6304 3.54174 18.4201 3.33114C18.2094 3.12042 17.9229 3.00165 17.6249 3.00163H6.37443C6.07654 3.00173 5.7913 3.1205 5.58066 3.33114C5.37001 3.54179 5.25125 3.82703 5.25114 4.12492V13.8757C5.25124 14.1736 5.37001 14.4588 5.58066 14.6695C5.7913 14.8801 6.07654 14.9989 6.37443 14.999H8.25049C8.66509 14.9994 9.00178 15.3356 9.00179 15.7503C9.00179 16.165 8.66509 16.5013 8.25049 16.5016H6.37443C5.67805 16.5015 5.00983 16.2252 4.51741 15.7327C4.02499 15.2403 3.74864 14.5721 3.74854 13.8757V4.12492C3.74864 3.42854 4.02499 2.76032 4.51741 2.2679C5.00983 1.77548 5.67805 1.49913 6.37443 1.49902H17.6249C18.3213 1.49904 18.9894 1.7755 19.4819 2.2679C19.9743 2.76032 20.2507 3.42854 20.2508 4.12492V13.8757C20.2507 14.5721 19.9744 15.2403 19.4819 15.7327C18.9894 16.2251 18.3213 16.5016 17.6249 16.5016H15.7503C15.3354 16.5016 14.999 16.1652 14.999 15.7503C14.999 15.3354 15.3354 14.999 15.7503 14.999H17.6249C17.9229 14.999 18.2094 14.8802 18.4201 14.6695C18.6304 14.4589 18.7481 14.1733 18.7482 13.8757Z" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", { d: "M11.5883 6.87223C11.8799 6.67972 12.2762 6.71072 12.5329 6.96742L16.2836 10.7181C16.5768 11.0115 16.5768 11.488 16.2836 11.7813C15.9902 12.0746 15.5137 12.0745 15.2203 11.7813L12.0013 8.56229L8.78228 11.7813C8.48891 12.0746 8.0124 12.0746 7.71903 11.7813C7.42567 11.488 7.42571 11.0115 7.71903 10.7181L11.4697 6.96742L11.5883 6.87223Z" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", { d: "M11.249 21.7508V8.25081C11.249 7.83591 11.5854 7.49951 12.0003 7.49951C12.4152 7.49951 12.7516 7.83591 12.7516 8.25081V21.7508C12.7516 22.1657 12.4152 22.5021 12.0003 22.5021C11.5854 22.5021 11.249 22.1657 11.249 21.7508Z" }, null, -1)
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { style: {"color":"#888888","font-size":"12px"} }, "Faça o upload da imagem", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { style: {"color":"#888888","font-size":"10px","margin-top":"-1rem"} }, "Formatos: JPG, PNG, SVG ou PDF (máx: 5 MB)", -1)
const _hoisted_33 = {
  key: 1,
  class: "signature-preview"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 2,
  class: "div-buttons"
}
const _hoisted_36 = { class: "text-option" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "label-text" }, "Cursiva", -1)
const _hoisted_38 = { class: "text-option" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "label-text" }, "Elegante", -1)
const _hoisted_40 = { class: "text-option" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "label-text" }, "Simples", -1)
const _hoisted_42 = { class: "modal-footer" }
const _hoisted_43 = { class: "buttons-footer" }

import { ref, reactive, onMounted, watch, nextTick } from 'vue'
import type { ISignatureData } from '../Interfaces/ISignatureData'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignatureModal',
  props: {
    toggle: { type: Boolean },
    modelValue: {},
    initialData: {}
  },
  emits: ["close", "save", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

const inputFile = ref<HTMLInputElement | null>(null);

function clickFile() {
    inputFile.value.click();
}

const activeTab = ref<string>('text');
const selectedFont = ref<string>('cursive');
const canvasRef = ref<HTMLCanvasElement | null>(null)
let ctx: CanvasRenderingContext2D | null = null
let drawing = false
let lastX = 0
let lastY = 0

const signatureData = reactive<ISignatureData>({
    name: '',
    role: '',
    company: '',
    signature: null
});

// Indica se o usuário mexeu na assinatura (desenhou, enviou arquivo, escolheu fonte ou removeu).
// Se não mexeu, a assinatura já cadastrada é mantida ao salvar.
const signatureChanged = ref<boolean>(false);

function selectFont(font: string) {
    selectedFont.value = font;
    signatureChanged.value = true;
}

function tabSelect(activeTabSelect:string){
    activeTab.value = activeTabSelect

    if(!activeTab.value){
        activeTab.value = 'text'
    }
}

function saveSignatureData(){
    emit('save', signatureData);
}

function setupCanvasSize(canvasElement: HTMLCanvasElement) {
  if (!canvasElement) return;
  
  canvasRef.value = canvasElement;
  
  const ratio = window.devicePixelRatio || 1;
  const width = canvasElement.clientWidth;
  const height = canvasElement.clientHeight;
  
  canvasElement.width = Math.round(width * ratio);
  canvasElement.height = Math.round(height * ratio);
  
  ctx = canvasElement.getContext('2d');
  if (ctx) {
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#000';
  }
}

function getPointerPos(e: PointerEvent) {
  const c = canvasRef.value
  if (!c) return { x: 0, y: 0 }
  const rect = c.getBoundingClientRect()
  return { x: e.clientX - rect.left, y: e.clientY - rect.top }
}

function startDraw(e: PointerEvent) {
  const c = canvasRef.value;
  if (!c) return;
  drawing = true;
  signatureChanged.value = true;
  const pos = getPointerPos(e);
  lastX = pos.x; lastY = pos.y;
  try { c.setPointerCapture(e.pointerId); } catch {}
}
function moveDraw(e: PointerEvent) {
  if (!drawing || !ctx) return
  const pos = getPointerPos(e)
  ctx.beginPath()
  ctx.moveTo(lastX, lastY)
  ctx.lineTo(pos.x, pos.y)
  ctx.stroke()
  lastX = pos.x
  lastY = pos.y
}

function endDraw(e: PointerEvent) {
  drawing = false;
  try { canvasRef.value?.releasePointerCapture(e.pointerId); } catch {}
}

function clearCanvas() {
  const c = canvasRef.value
  if (!c || !ctx) return
  const ratio = window.devicePixelRatio || 1
  ctx.clearRect(0, 0, c.width / ratio, c.height / ratio)
  signatureData.signature = null
  signatureChanged.value = true
}

function saveSignature() {
  const c = canvasRef.value
  if (!c) return
  signatureData.signature = c.toDataURL('image/png')
}

function handleFile(evt: Event) {
  const input = evt.target as HTMLInputElement;
  const file = input.files?.[0];
  if (!file) return;
  const maxBytes = 5 * 1024 * 1024;
  if (file.size > maxBytes) {
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    signatureData.signature = reader.result as string;
    signatureChanged.value = true;
  };
  reader.readAsDataURL(file);
  input.value = '';
}

function emitRemove() {
  emit('update:modelValue', null)
}

function removeUploadSignature() {
  signatureData.signature = null;
  signatureChanged.value = true;
}
function download() {
  const a = document.createElement('a')
  a.href = signatureData.signature || ''
  a.download = 'assinatura.png'
  document.body.appendChild(a)
  a.click()
  a.remove()
}


function saveTextSignature() {
    const canvas = document.createElement('canvas');
    
    canvas.width = 800; 
    canvas.height = 200;
    const context = canvas.getContext('2d');
    
    if (context) {
        context.clearRect(0, 0, canvas.width, canvas.height);
        
        const textToDraw = signatureData.name || 'Assinatura';
        
        let maxFontSize = 130; 
        let fontName = 'Montserrat';
        let fontWeightAndStyle = '';

        if (selectedFont.value === 'cursive') {
            maxFontSize = 130;
            fontName = 'Great Vibes';
            fontWeightAndStyle = 'bold ';
        } else if (selectedFont.value === 'elegant') {
            maxFontSize = 130;
            fontName = 'Playfair Display';
            fontWeightAndStyle = 'italic 600 ';
        }
        
        let currentFontSize = maxFontSize;
        const padding = 40; // Margem de segurança nas laterais para não encostar na borda
        const maxWidth = canvas.width - padding;

        do {
            context.font = `${fontWeightAndStyle}${currentFontSize}px ${fontName}`;
            currentFontSize--;
        } while (context.measureText(textToDraw).width > maxWidth && currentFontSize > 20);
        
        context.fillStyle = '#000000';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        
        context.fillText(textToDraw, canvas.width / 2, canvas.height / 2);
        
        signatureData.signature = canvas.toDataURL('image/png');
    }
}


function onSaveClick() {
  // Só gera uma nova imagem se o usuário alterou a assinatura ou se ainda não existe uma
  if (signatureChanged.value || !signatureData.signature) {
    if (activeTab.value === 'draw') {
      saveSignature();
    } else if (activeTab.value === 'text') {
      saveTextSignature();
    }
  }

  const payload: ISignatureData = { ...signatureData };
  emit('save', payload);
  emit('close');

  console.log('Signature data saved:', payload);
}

watch(() => props.toggle, async (newVal) => {
    if (newVal) {
        activeTab.value = 'text';

        // Carrega os dados já cadastrados (ou limpa, se não houver) sempre que o modal abre
        signatureData.name = props.initialData?.name ?? '';
        signatureData.role = props.initialData?.role ?? '';
        signatureData.company = props.initialData?.company ?? '';
        signatureData.signature = props.initialData?.signature ?? null;
        signatureChanged.value = false;

        await nextTick();
        
        const canvas = document.querySelector('.signature-canvas') as HTMLCanvasElement;
        if (canvas) {
            setupCanvasSize(canvas);
        }
    }
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  return (props.toggle)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((signatureData.name) = $event)),
                  placeholder: "Ex: Maria Silva"
                }, null, 512), [
                  [_vModelText, signatureData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((signatureData.role) = $event)),
                  placeholder: "Ex: Gerente Comercial"
                }, null, 512), [
                  [_vModelText, signatureData.role]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((signatureData.company) = $event)),
                  placeholder: "Ex: Nome da empresa"
                }, null, 512), [
                  [_vModelText, signatureData.company]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("section", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(['tab-btn', { active: activeTab.value === 'text' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (tabSelect('text')))
                }, [
                  _hoisted_18,
                  _createTextVNode(" Texto ")
                ], 2),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(['tab-btn', { active: activeTab.value === 'draw' }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (tabSelect('draw')))
                }, [
                  _hoisted_19,
                  _createTextVNode(" Desenhar ")
                ], 2),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(['tab-btn', { active: activeTab.value === 'upload' }]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (tabSelect('upload')))
                }, [
                  _hoisted_20,
                  _createTextVNode(" Upload ")
                ], 2)
              ]),
              _createElementVNode("section", _hoisted_21, [
                (activeTab.value == 'draw')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", { class: "signature-header" }, [
                        _hoisted_22,
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-clear",
                          onClick: clearCanvas
                        }, _hoisted_24)
                      ]),
                      _createElementVNode("canvas", {
                        ref: el => { if (el) setupCanvasSize(el as HTMLCanvasElement) },
                        class: "signature-canvas",
                        style: {"border-radius":"1.2rem","border":"1px solid #ddd","touch-action":"none","width":"100%","height":"150px","display":"block"},
                        onPointerdown: startDraw,
                        onPointermove: moveDraw,
                        onPointerup: endDraw,
                        onPointercancel: endDraw
                      }, null, 544)
                    ], 64))
                  : _createCommentVNode("", true),
                (activeTab.value == 'upload')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!signatureData.signature)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_26, _hoisted_30)),
                            _hoisted_31,
                            _hoisted_32,
                            _createElementVNode("button", {
                              type: "button",
                              style: {"background-color":"#FFFFFF","color":"#ED2B46","padding":".5rem 1rem","font-size":"12px","text-align":"center","border-radius":"0.6rem","border":"none","box-shadow":"0px 3px 0px 0px rgba(0,0,0,0.1)"},
                              onClick: clickFile
                            }, "Selecionar arquivo"),
                            _createElementVNode("input", {
                              ref_key: "inputFile",
                              ref: inputFile,
                              type: "file",
                              accept: "image/png,image/jpeg,image/svg+xml,application/pdf",
                              onChange: handleFile,
                              class: "d-none"
                            }, null, 544)
                          ]))
                        : _createCommentVNode("", true),
                      (signatureData.signature)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("img", {
                              src: signatureData.signature,
                              alt: "Preview da assinatura",
                              class: "img-fluid"
                            }, null, 8, _hoisted_34),
                            _createElementVNode("div", { class: "signature-actions" }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-remove",
                                onClick: removeUploadSignature
                              }, "Remover"),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-download",
                                onClick: download
                              }, "Download")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (activeTab.value == 'text')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("button", {
                          class: _normalizeClass(['buttons-text', 'font-cursive', { active: selectedFont.value === 'cursive' }]),
                          type: "button",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (selectFont('cursive')))
                        }, _toDisplayString(signatureData.name || 'Assinatura'), 3),
                        _hoisted_37
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("button", {
                          class: _normalizeClass(['buttons-text', 'font-elegant', { active: selectedFont.value === 'elegant' }]),
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (selectFont('elegant')))
                        }, _toDisplayString(signatureData.name || 'Assinatura'), 3),
                        _hoisted_39
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("button", {
                          class: _normalizeClass(['buttons-text', 'font-simple', { active: selectedFont.value === 'simple' }]),
                          type: "button",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (selectFont('simple')))
                        }, _toDisplayString(signatureData.name || 'Assinatura'), 3),
                        _hoisted_41
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("button", {
                type: "button",
                class: "buttonCancelar",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (emit('close')))
              }, "Cancelar"),
              _createElementVNode("button", {
                type: "button",
                class: "buttonSalvar",
                onClick: onSaveClick
              }, "Salvar")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})